import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ImageDialogComponent } from '../../base/image-dialog/image-dialog.component';
import { PlatformDialogTestComponent } from '../platform-dialog-test/platform-dialog-test.component';
import { PlatformSelectionModalComponent } from '../platform-selection-modal/platform-selection-modal.component';

@Component({
  selector: 'app-platform-card',
  templateUrl: './platform-card.component.html',
  styleUrls: ['./platform-card.component.scss'],
})
export class PlatformCardComponent {
  @Input() data: any;

  constructor(private dialog: MatDialog) {}

  purchase() {
    // Netflix || Disney+ || Prime Video || MAX || Crunchyroll
    if (
      this.data.id === 2 ||
      this.data.id === 6 ||
      this.data.id === 11 ||
      this.data.id === 5 ||
      this.data.id == 57
    ) {
      this.dialog
        .open(PlatformSelectionModalComponent, {
          data: Object.assign({}, this.data),
          width: '728px',
        })
        .afterClosed()
        .subscribe((r) => {
          if (r)
            this.dialog.open(PlatformDialogTestComponent, {
              data: Object.assign({}, this.data),
              autoFocus: false,
              panelClass: 'app-dialog',
            });
        });
    } else {
      this.dialog.open(PlatformDialogTestComponent, {
        data: Object.assign({}, this.data),
        autoFocus: false,
        panelClass: 'app-dialog',
      });
    }
  }

  openHelp() {
    if (this.data.help_image) {
      this.dialog.open(ImageDialogComponent, {
        data: {
          title: '产品介绍 - ' + this.data.name,
          fileid: this.data.help_image,
        },
        autoFocus: false,
        panelClass: 'app-dialog',
        maxHeight: '95%',
      });
    } else if (this.data.help_link) {
      window.open(this.data.help_link, '_blank');
    }
  }
}
